import React, { useContext, useState } from 'react'
import {FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaPinterest, FaCartPlus} from "react-icons/fa"
import RelatedProduct from './RelatedProduct/RelatedProduct'
import "./singleprod.css"
import { useParams } from 'react-router-dom'
import useFetch from '../../hooks/useFetch'
import { Context } from '../../utils/context'

function SingleProduct() {
    const [quantity, setQuantity] = useState(1);
    const {id} = useParams();
    const {data} = useFetch(`/api/products?populate=*&[filters][id]=${id}`);
    const {handleAddToCart} = useContext(Context);
    const increase = () => {
        setQuantity((prevState) => prevState + 1)
    };

    const decrease = () => {
        setQuantity((prevState) => {
            if(prevState === 1){
                return 1;
            }
            return prevState - 1
        })

    };

    const product = data?.data[0]?.attributes;
  return (
    <div className='s-prod-main-content'>
        <div className="s-prod-layout">
            <div className="s-prod-page">
                <div className="s-prod-left">
                    <img src={product?.img?.data[0]?.attributes?.url} alt="" />
                </div>
                <div className="s-prod-right">
                    <span className="name">{product?.title}</span>
                    <span className="price">&#8377;{product?.price}</span>
                    <span className="desc">{product?.desc}</span>

                    <div className="cart-btns">
                        <div style={{fontWeight: "500"}} className="qty-btns">
                            <span onClick={decrease}>-</span>
                            <span>{quantity}</span>
                            <span onClick={increase}>+</span>
                        </div>
                        <button className='add-cart-btn'
                            onClick={() => {
                                handleAddToCart(data?.data[0], quantity);
                                setQuantity(1);
                            }}
                        >
                            <FaCartPlus size={20} />
                            ADD TO CART
                        </button>
                    </div>

                    <span className='divider' />

                    <div className="info-item">
                        <span className="text-bold">
                            Cartgory: 
                            <span style={{fontWeight: "500"}}> {product?.categories?.data?.[0]?.attributes?.title}</span>
                        </span>
                        <span className="text-bold">
                            Share:
                            <span className='social-icons'>
                                <a href="https://www.instagram.com/_tanzeel_kh/"><FaFacebookF size={16}/></a>
                                <a href="https://www.instagram.com/_tanzeel_kh/"><FaInstagram size={16}/></a>
                                <a href="https://twitter.com/tanzeeltwt"><FaTwitter size={16}/></a>
                                <a href="https://www.linkedin.com/in/ahamad-tanzeel-khan-1b1760252/"><FaLinkedinIn size={16}/></a>
                                <a href="https://www.linkedin.com/in/ahamad-tanzeel-khan-1b1760252/"><FaPinterest size={16}/></a>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <RelatedProduct productId={id} categoryId={product?.categories?.data[0]?.id} />
        </div>
    </div>
  )
}

export default SingleProduct
